import * as React from 'react';

function SvgFlag(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M3.714 22A.715.715 0 013 21.286V3.613a1.071 1.071 0 01.531-.925C4.071 2.374 5.16 2 7.286 2c1.66 0 3.519.657 5.158 1.236 1.32.466 2.567.907 3.413.907a8.207 8.207 0 003.17-.647.804.804 0 011.116.74v9.793a.894.894 0 01-.536.817c-.389.17-1.808.725-3.75.725-1.077 0-2.427-.318-3.857-.656-1.606-.38-3.267-.772-4.714-.772-1.646 0-2.489.249-2.857.407v6.736a.714.714 0 01-.715.714z" })));
}

export default SvgFlag;
